import { useEffect, useState } from 'react';
import moment from 'moment-timezone';

const TICK_MS = 60 * 1000;

// The current time, refreshed every minute while the page is in view and as soon as it comes
// back, so times that have already started stop being offered.
const useNow = () => {
  const [now, setNow] = useState(() => moment());

  useEffect(() => {
    let timer: number | undefined;
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      timer = window.setInterval(() => setNow(moment()), TICK_MS);
    };
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        stop();
        return;
      }
      setNow(moment());
      start();
    };

    start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);

  return now;
};

export default useNow;
